import React, { useState } from 'react';
import "./NavBar.css";
import logo from "../../assets/images/logo2.png";
import { Link } from 'react-router-dom';
import menu_icon from "../../assets/images/menu-icon.png";

const Nav = () => {

      const [mobileMenu, setMobileMenu] = useState(false);
      const toggleMenu = ()=>{
        mobileMenu ? setMobileMenu(false) : setMobileMenu(true);
      }

  return (
    <nav className='container dark-nav'>
      <Link to='/'>
      <img src={logo} alt='logo' className='logo'/>
      </Link>
      <ul className={mobileMenu?'':'hide-mobile-menu'}>
        <li><Link to='/home'>Home</Link></li>
        <li><Link to='/about'>About us</Link></li>
        <li><Link to='/services'>Services</Link></li>
        {/* <li><Link to='/products'>Products</Link></li>
        <li><Link to='/curriculum'>Catalogue</Link></li> */}

        <li><Link to='/contact'><button className='btn'>Contact</button></Link></li>
      </ul>
      <img src={menu_icon} alt='menu' className='menu-icon' onClick={toggleMenu}/>
    </nav>
  )
}

export default Nav
